export const CATEGORIES = ["Weddings", "Portraits", "Travel", "Films", "Commercial", "Events"];

export const fmtBytes = (b) => {
  if (!b) return "0 MB";
  if (b >= 1e9) return `${(b / 1e9).toFixed(2)} GB`;
  if (b >= 1e6) return `${(b / 1e6).toFixed(1)} MB`;
  return `${(b / 1e3).toFixed(0)} KB`;
};

export const formatApiError = (detail) => {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail?.msg || detail);
};

export const Label = ({ children }) => (
  <label className="font-mono text-[9px] tracking-[0.35em] uppercase text-mute">{children}</label>
);

export const SectionTitle = ({ icon: Icon, children, count }) => (
  <h2 className="font-display text-sm tracking-[0.3em] uppercase text-ivory flex items-center gap-2">
    {Icon && <Icon size={14} className="text-amber" />} {children}
    {count !== undefined && <span className="font-mono text-[10px] text-mute tracking-normal">({count})</span>}
  </h2>
);

export const ghostBtn =
  "flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] uppercase text-ash hover:text-amber border border-line hover:border-amber/50 px-4 py-2.5 transition-all disabled:opacity-40";

export const solidBtn =
  "font-mono text-[11px] tracking-[0.3em] uppercase bg-ivory text-ink py-4 hover:bg-amber disabled:opacity-40 transition-colors flex items-center justify-center gap-2";
